import {Particles} from "../../Core/Particles";
import {texture} from "../../Core/AssetHelpers";

export class MusicNotesBurst extends Particles {

    constructor(width: number, height: number) {
        super([1, 2].map(i => texture(`music-note-${i}`)!), {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 3 / (400 / height),
                "end": 1,
                "minimumScaleMultiplier": 0.5
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 200,
                "end": 0,
                "minimumSpeedMultiplier": 0.7
            },
            "acceleration": {
                "x": 0,
                "y": 500
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": -60,
                "max": 60
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": -50,
                "max": 50
            },
            "lifetime": {
                "min": 0.2,
                "max": 0.8
            },
            "blendMode": "normal",
            "frequency": 0.012,
            "emitterLifetime": 0.1,
            "maxParticles": 100,
            "pos": {
                "x": 0,
                "y": 0
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": -width * 0.5,
                "y": -height * 0.6,
                "w": width,
                "h": height
            }
        });
        this.emitter.autoUpdate = true;
    }
}